/**
 * These components can be overriden with custom components. These names may also be used to create instances of the components.
 *
 * @example
 * ComponentFactory.instanceOf(ComponentName.Header, {...});
 *
 * @example
 * registerDefaultApplicationComponents()
 *     .override(ComponentName.Header, <h1>MyCustomHeader</h1>);
 */
export const ComponentName = {
    Header: "Header",
    HeaderMenu: "HeaderMenu",

    InitialLoadingSpinner: "loadingSpinner",
    BusyOverlay: "BusyOverlay",
    MessageBox: "MessageBox",

    ProductTitle: "ProductTitle",
    ProductText: "ProductText",
    ProductPrice: "ProductPrice",

    CuiApp: "CuiApp",
    AssemblyApp: "AssemblyApp",
    Visualization: "Visualization",
    ARDialog: "ARDialog"
}

export const ReadyState = {
    Ready: "READY",
    NotReady: "NOT_READY",
    Conflict: "CONFLICT"
}

export const NodeMessageType = {
    Error: "error"
}

/**
 * Describes possible positions in the {@link BorderLayout} component.
 */
export const Orientation = {
    Center: "center",
    North: "north",
    East: "east",
    West: "west",
    South: "south"
}

/**
 * Describes the possible containers that can be layouted with the {@link BorderLayout} component.
 */
export const BorderLayoutContent = {
    Header: "header",
    Configuration: "configuration",
    VisualEditor: "visualEditor"
}

/**
 * Events thrown from this library.
 */
export const Events = {
    ShowVisualization: "ShowVisualization",
    HideVisualization: "HideVisualization",
    ShowPrices: "ShowPrices",
    HidePrices: "HidePrices",
    AppStateUpdated: "AppStateUpdated",
    ShowARDialog: "ShowARDialog",
    ShowError: "ShowError"
}

export const ExternalMessages = {
    ExternalProcessingStarted: "EXTERNAL_PROCESSING_STARTED",
    ExternalProcessingFinished: "EXTERNAL_PROCESSING_FINISHED",
    ExternalUserInteractionRequired: "EXTERNAL_USERINTERACTION_REQUIRED",
    SupportsSaveDataGeneration: "SUPPORTS_SAVE_DATA_GENERATION",
    GenerateSaveData: "GENERATE_SAVE_DATA",
    SaveDataGenerationFailed: "SAVE_DATA_GENERATION_FAILED@@",
    SaveDataGenerated: "SAVE_DATA_GENERATED@@"
}

export const TRANSLATION_SCOPE = "configurator"

export const VisualizationOptions = {
    AR: "ar-service",
    DXF: "dxf-service",
    IFC: "ifc-service",
    STEP: "step-service"
}

export interface IHeaderSettings {
    ShowPrices: string
    ShowVisualization: string
    get: (key: string, defaultValue: boolean) => boolean
}

export const HeaderSettings: IHeaderSettings = {
    ShowPrices: "encoway.cui.showPrices",
    ShowVisualization: "encoway.cui.showVisualization",
    get: (key, defaultValue) => {
        const value = window.localStorage.getItem(key)
        if (value === null) {
            return defaultValue
        }
        return value === "true"
    }
}
